import { Component, Input, OnChanges } from '@angular/core';

import { FilterTypeTextModel } from '../../models/filter-type-text.model';
import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { IncludeExcludeEnum } from '../../enums/include-exclude.enum';

@Component({
    selector: 'agpr-filter-text',
    templateUrl: './filter-text.component.html',
    styleUrls: ['./filter-text.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: FilterTextComponent
        }
    ],
    standalone: false
})
export class FilterTextComponent extends AbstractFilterTypeComponent implements OnChanges {
    @Input() declare filter: FilterTypeTextModel;

    readonly buttonStyles = ButtonTypesEnum;
    readonly includeExcludeEnum = IncludeExcludeEnum;

    value: string[];
    searchQuery: string;


    ngOnChanges(): void {
        this.searchQuery = '';
        this.refresh();
    }

    /**
     * Refreshes the current value from the filter
     */
    refresh(): void {
        this.value = this.filter.getCurrentValue();
    }

    /**
     * Updates the current value of the filter
     */
    handleChange(): void {
        this.filter.setCurrentValue(this.value);
    }

    /**
     * Adds a search query if it did not previously exist
     */
    search(): void {
        if (this.filter.prefix && this.searchQuery.indexOf(this.filter.prefix) !== 0) {
            this.searchQuery = this.filter.prefix + this.searchQuery;
        }
        if (this.filter.canAddCurrentItem(this.searchQuery)) {
            this.value.push(this.searchQuery.trim());
            this.filter.setCurrentValue(this.value);
            this.searchQuery = '';
        }
    }
}
